var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"myMenu"},[_c('div',{staticClass:"menuDiv",on:{"click":function($event){return _vm.monthCard()}}},[_vm._v("\n    集团用户-月卡续费\n  ")]),_vm._v(" "),_c('div',{staticClass:"menuDiv",on:{"click":function($event){return _vm.invoice()}}},[_vm._v("\n    集团用户-电子发票\n  ")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-39967de2","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/menu/myMenu.vue
// module id = null
// module chunks = 